import axios from 'axios'
import {getToken, removeToken} from "./auth.js";
import {ElMessage} from "element-plus";
import router from "../router/index.js";
import {useLoadingStore} from "../stores/loadingStore.js";

const service = axios.create(
    {
        baseURL: import.meta.env.VITE_API_BASE_URL,
        timeout: 60000
    }
)


// 請求攔截
service.interceptors.request.use(
    (config) => {
        const token = 'Bearer ' +getToken()
        if (token) {
            config.headers.Authorization = `${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// 響應攔截
service.interceptors.response.use(
    (response) => {
        const loading = useLoadingStore()
        loading.cancel()
        const contentType = response.headers['content-type']
        const isFile = contentType.includes('application/pdf') ||
            contentType.includes('application/octet-stream') ||
            contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        if (isFile) {
            return response
        }
        if (response.data.code === 200) {
            return response.data;
        } else {
            if (response.data.code === 401) {
                removeToken()
                router.push('/login')
            }
            ElMessage({
                message: response.data.msg || '請求異常，請聯繫管理員處理！',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error('請求失敗'));
        }
    },
    (error) => {
        ElMessage({
            message: error.msg || '請求異常，請聯繫管理員處理！',
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error);
    }
);


export default service;

